import React, { useState } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import { Button } from '@material-ui/core';

import { useStyles } from './styles';

function AssinaturaContratadaModal() {
  const classes = useStyles();

  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <h2 id="simple-modal-title">Assinatura contratada</h2>
          <p id="simple-modal-description">
            A assinatura foi contratada com sucesso!
          </p>
          <div>
            <Button variant="contained" color="primary" onClick={handleClose}>
              Fechar
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}

export default AssinaturaContratadaModal;
